<app-cart-layout>
  <!-- Navbar -->
  <!--Main layout-->
  <main class="mt-5 pt-4" *ngIf="model?.CartOrder">
    <div class="container">
      <span id="shippingAddressBookmark"> </span>
      <div class="row" *ngIf="!isLoggedIn">
        <div class="col">
          <div data-testid="checkout-as-guest" class="alert alert-info" role="alert">Checkout as <strong>Guest</strong></div>
        </div>
      </div>
      <!--Grid row-->

      <div class="row" style="padding-top: 15px">
        <!--Grid column-->
        <div class="col-lg-8 col-sm-12 col-xs-12 mb-4">
          <!-- Card -->

          <div class="card z-depth-1">
            <div class="card-body">
              <div class="checkout-step">
                <div class="backdrop" *ngIf="(service.isAnythingLoading$ | async) || (payerAuthService.isPayerAuthPending$ | async)">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <!-- Address -->
                <div class="row">
                  <h4 class="pb-3 pt-2 col">
                    <strong class="mr-3"><span class="text-primary">My Account
                      </span>Info</strong>
                  </h4>
                  <div class="col col-auto" *ngIf="isLoggedIn">
                    <app-address-pick addressType="{{AddressType.Shipping}}"></app-address-pick>
                  </div>
                  <div class="col col-auto" *ngIf="cartOrder.ShippingAddressCompleted">
                    <a mdbRipple outline="true" mdbWavesEffect class="p-md-2 text-dark waves-effect"
                      (click)="editMyAccount($event)"><span data-testid="checkout-change-address" class="pull-right"><i class="fas fa-edit"></i> Change
                        Address</span></a>
                  </div>
                </div>
                <ng-template [ngIf]="isLoggedIn || (isEmailCompleted && cartOrder.ShippingAddressCompleted)"
                  [ngIfElse]="emailEdit">
                  <div class="row">
                    <div class="col">{{ model.CartOrder.Email }}</div>
                  </div>
                </ng-template>
                <ng-template #emailEdit>
                  <form class="form-box form-validator md-form" [formGroup]="emailForm">
                    <!--email-->
                    <div class="md-form mb-2">
                      <input type="text" id="email" class="form-control" placeholder="youremail@example.com"
                        formControlName="email" mdbInput mdbValidate data-testid="shipping-email-input" />
                      <label for="email">Email </label>
                      <mdb-error *ngIf="emailHasError('email', 'required')">Email is required</mdb-error>
                      <mdb-error *ngIf="emailHasError('email', 'maxlength')">Email's maximum length is 80
                        symbols</mdb-error>
                      <mdb-error *ngIf="emailHasError('email', 'invalid')">Email is in incorrect format</mdb-error>
                      <mdb-error *ngIf="emailHasError('email', 'emailExists')" data-testid="checkout-existing-account-error">
                        We have an account with this email. To use it, please 
                        <a href="#"
                          (click)="onAccountExists($event)" 
                          data-testid="existing-account-exists-login-link">login
                        </a>.
                      </mdb-error>
                    </div>
                  </form>
                </ng-template>

                <ng-template [ngIf]="isEmailCompleted && cartOrder.ShippingAddressCompleted" [ngIfElse]="shippingEdit">
                  <app-address-view [address]="shippingAddress" data-testid="completed-shipping-address"></app-address-view>
                </ng-template>
                <ng-template #shippingEdit>
                  <app-address-edit 
                      [address]="shippingAddress" 
                      [scope]="'shipping'"
                      #shippingEditor
                  >
                  </app-address-edit>
                  <div class="row">
                    <div class="col">
                      <button mdbRipple type="button" class="btn btn-primary" (click)="updateShippingAddress()" data-testid="continue-to-delivery">
                        Continue to Delivery Method
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
              <!-- Material column sizing form -->

              <div id="billingAddressBookmark"></div>

              <hr class="divider" />

              <div class="checkout-step">
                <div class="row">
                  <div class="col-sm-12">
                    <h4><strong><span class="text-primary">Select Delivery</span> Method</strong></h4>
                  </div>
                </div>
                <div class="row">
                  <ng-container *ngIf="cartOrder.ShippingAddressCompleted; else invalidShipping">
                    <div class="col-sm-12">
                      <app-shipping 
                          [pageScope]="'checkout'"
                          [style.min-height]="isDigitalOrder ? '130px' : '220px'"
                      >
                      </app-shipping>
                    </div>
                  </ng-container>
                  <ng-template #invalidShipping>
                    <div class="col-sm-12 alert alert-danger" data-testid="account-not-complete-error">
                      Not available because your account info is not completed
                    </div>
                  </ng-template>
                </div>
              </div>
                
              <hr class="divider" />

              <div class="checkout-step">
                <div class="backdrop" *ngIf="(service.isAnythingLoading$ | async) || (payerAuthService.isPayerAuthPending$ | async)">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <div class="row">
                  <h4 class="col">

                    <strong><span class="text-primary">Select Billing</span> Address</strong>
                  </h4>
                  <div class="col col-auto" *ngIf="isLoggedIn && !BillingIsShipping">
                    <app-address-pick addressType="{{AddressType.Billing}}"></app-address-pick>
                  </div>
                  <div class="col col-auto">
                    <a *ngIf="cartOrder.BillingAddressCompleted && !BillingIsShipping" mdbRipple outline="true"
                       data-testid="change-billing-address-button"
                      mdbWavesEffect class="p-md-2 text-dark waves-effect" (click)="editBilling($event)"><span
                        class="pull-right"><i class="fas fa-edit"></i> Change Address</span></a>
                  </div>
                </div>
                <ng-template [ngIf]="cartOrder.BillingAddressCompleted || BillingIsShipping" [ngIfElse]="billingEdit">
                  <div class="row">
                    <div class="col">
                      <mdb-checkbox [(ngModel)]="BillingIsShipping" data-testid="billing-is-same-as-shipping-checkbox">My billing name &amp; address are the same as my
                        shipping</mdb-checkbox>
                    </div>
                  </div>
                  <app-address-view [address]="billingAddress" data-testid="completed-billing-address"></app-address-view>
                </ng-template>
                <ng-template #billingEdit>
                  <app-address-edit [address]="billingAddress" [scope]="'billing'" #billingEditor>
                  </app-address-edit>
                  <div class="row">
                    <div class="col">
                      <button mdbRipple type="button" class="btn btn-primary" (click)="continueToPayment()" data-testid="continue-to-payment">
                        Continue to Payment
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>

              <hr class="divider" />

              <div class="checkout-step">
                <div class="backdrop" *ngIf="(service.isAnythingLoading$ | async) || (payerAuthService.isPayerAuthPending$ | async)">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                  
                <h4 style="padding-bottom: 20px">
                  <strong><span class="text-primary">Select Your </span> Payment</strong>
                </h4>
                <div class="checkout-step pb-2" *ngIf="!isBuyingGiftCard">
                  <app-gift-cards></app-gift-cards> 
                </div>

                <div class="row">
                  <div class="col-lg-7 col-sm-12 col-xs-12 border-right">
                    <app-checkout-payment></app-checkout-payment>
                  </div>

                  <div class="col-lg-5 col-xs-12 col-sm-12">
                    <app-summary></app-summary>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Grid column-->
        <div class="col-lg-4 col-sm-12 col-xs-12 mb-4">
          <!-- Cart -->
          <checkout-cart-items></checkout-cart-items>

          <!--Grid column-->
        </div>

        <!--Grid row-->
      </div>
    </div>
  </main>
  <!--Main layout-->
</app-cart-layout>
<!--/.Footer-->
<!-- SCRIPTS -->
<!-- JQuery -->